import { GlobalBanner, Button, Typography } from '@getsynapse/design-system';
import { useState } from 'react';
import intl from 'react-intl-universal';
import DeclinedRequestInfoModal from './DeclinedRequestInfoModal';
import { Request } from 'utils/customTypes';
import moment from 'moment';
import { DATE } from 'utils/constants';
import classNames from 'classnames';

type Props = {
  requestData: Request;
  sidePanel?: boolean;
  dataTestId?: string;
};

const DeclinedRequestBanner = ({
  requestData,
  sidePanel,
  dataTestId,
}: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const declineDate = moment(
    requestData.decision_date ?? requestData.decisionDate
  ).format(DATE.SHORT_FORMAT);
  const reason = intl.get(
    `REQUESTS_LIST_PAGE.MODAL.DECLINE_REQUEST.REASONS.${requestData.data?.declination?.reason}`
  );

  return (
    <>
      <DeclinedRequestInfoModal
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        comments={requestData.data?.declination?.comments!}
        declineDate={declineDate}
        reason={reason}
        details={requestData.data?.declination?.details}
      />
      <GlobalBanner
        variant='warning'
        hasCloseIcon
        className={classNames(`${sidePanel ? 'mb-4' : 'mt-2'}`)}
        iconProps={{
          'data-testid': dataTestId,
        }}
      >
        {() => {
          return (
            <div className='flex justify-between items-start'>
              <div>
                <Typography
                  variant='body'
                  className='text-warning-darker leading-6'
                  data-testid='declined-request-banner-text-one'
                >
                  {intl.getHTML(
                    'REQUEST_PAGE.DECLINED_REQUEST_BANNER.LINE_ONE',
                    { declineDate: declineDate }
                  )}
                </Typography>
                <Typography
                  variant='body'
                  className='text-warning-darker leading-6'
                  data-testid='declined-request-banner-text-two'
                >
                  {intl.get('REQUEST_PAGE.DECLINED_REQUEST_BANNER.LINE_TWO', {
                    reason: reason,
                  })}
                </Typography>
              </div>
              {!sidePanel && (
                <Button
                  onClick={() => {
                    setIsModalOpen(true);
                  }}
                  color='warning'
                  data-testid='declined-request-banner-button'
                >
                  {intl.get('REQUEST_PAGE.DECLINED_REQUEST_BANNER.BUTTON')}
                </Button>
              )}
            </div>
          );
        }}
      </GlobalBanner>
    </>
  );
};

export default DeclinedRequestBanner;
